import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const VISITOR_KEY = "mx_visitor_id_v1";

function getOrCreateVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      // 22-char base36 random id
      id = "v_" + Math.random().toString(36).slice(2, 12) + Math.random().toString(36).slice(2, 12);
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    // Private mode / storage disabled — fall back to sessionless id (won't dedupe across visits)
    return "v_anon_" + Math.random().toString(36).slice(2, 14);
  }
}

/**
 * Fire-and-forget page-view tracker. Records one visit per (visitor, path, day).
 * Skips /adminX and /admin routes (both client-side and enforced server-side).
 */
export default function PageViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/adminX") || pathname.startsWith("/admin")) return;
    const visitorId = getOrCreateVisitorId();
    // Small delay so bots that immediately close the tab are less likely to be counted
    const tm = setTimeout(() => {
      api.post("/analytics/track", { path: pathname, visitor_id: visitorId }).catch(() => {});
    }, 400);
    return () => clearTimeout(tm);
  }, [pathname]);

  return null;
}
